<template>
  <div>
    <div class="login-bg">
      <div class="vh-100">
        <div class="row justify-content-center align-items-center mx-0">
          <div class="col-sm-8 col-md-3 offset-md-9 px-0">
            <div class="card pb-1 border vh-100 bg-light position-relative">
              <div class="card-header bg-transparent border-0"></div>
              <div class="logo-badge bg-white shadow p-4 p-md-4 text-center">
                <img :src="require('../assets/Logo.svg')" alt="logo" class="img-fluid log-min-h" />
              </div>
              <div class="shadow-element"></div>
              <div class="card-body px-4">
                <p class="text-center mt-2 mb-4 h5">
                  <strong>Data Warehouse</strong>
                </p>
                <!-- <div class="alert alert-warning" v-if="signinError">{{ signinError }}</div> -->

                <div class="form-group ml-auto">
                  <button
                    class="btn btn-primary btn-block"
                    :disabled="busy"
                    type="button"
                    @click.prevent="signIn"
                  >Microsoft AD Login</button>
                </div>
                <div class="row align-self-end h-100">
                  <div class="col form-group mt-4 text-left cookie-opacity">
                    <a
                      href="https://www.coats.com/en/Privacy-and-Cookie-Policy"
                      class="btn-link"
                    >Our privacy and cookie policy.</a>
                  </div>
                </div>
              </div>
              <div class="card-footer bg-transparent border-0 text-center">
                <p class="mb-0 mt-3 text-center">© Coats Digital 2020</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { msalMixin } from "vue-msal";
//import { mapState } from "vuex";
export default {
  data: () => ({
    error: "",
    busy: false
  }),
  mixins: [msalMixin],
  // computed: {
  //   ...mapState(["signinError"])
  // },
  methods: {
    // async onSubmit() {
    //   this.error = "";
    //   this.busy = true;
    //   try {
    //     await this.$store.dispatch("login", {});
    //     this.busy = false;
    //     this.$router.push({ name: "Dashboard" });
    //   } catch (error) {
    //     this.busy = false;
    //     if (error.response) {
    //       if (error.response.status === 403) {
    //         this.error = "Invalid credentials";
    //       } else {
    //         this.error = error.response.data.message;
    //       }
    //     } else {
    //       console.log(error);
    //     }
    //   }
    // },
    async signIn() {
      this.busy = true;
      this.$msal.signIn();
    }
  }
};
</script>
